module.exports = __webpack_public_path__ + "img/4.e3628ac6.jpg";